import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useDeleteLlmInfo = () => {
  const {
    data: isDeleted,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const deleteLlmInfo = async (name: string) => {
    await call(`/admin/llm/${name}`, "DELETE");
  };

  return {
    deleteLlmInfo,
    isDeleted,
    isLoading,
    isFailed,
  };
};
